import React from 'react';
import { string } from 'prop-types';

const IconFolderClose = ({ fill = '#7994BB' }) => {
  return (
    <svg data-test="iconfolderclose" width="15" height="13" viewBox="0 0 15 13" fill="none">
      <path
        d="M12.5436 12.5H1.46029C0.65587 12.5 0.00195312 11.752 0.00195312 10.8333V2.16667C0.00195312 1.248 0.65587 0.5 1.46029 0.5H4.42712C4.66045 0.5 4.88037 0.604 5.04604 0.792667L5.87087 1.73533C5.9257 1.79867 5.99862 1.83333 6.07679 1.83333H12.5436C13.348 1.83333 14.002 2.58133 14.002 3.5V10.8333C14.002 11.752 13.348 12.5 12.5436 12.5Z"
        fill={fill}
      />
    </svg>
  );
};

IconFolderClose.propTypes = {
  fill: string,
};

export default IconFolderClose;
